

<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="uploadMethoRadio" :disabled="!ifTeamleaderAnchorPermission">

      <tl-radio
        name="uploadType"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />

      <tl-radio
        name="uploadType"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />
    </div>
    <div v-if="uploadMethod == 'manualUpload'">
      <div class="row" :disabled="!ifTeamleaderAnchorPermission">
        <div class="col-3 padding-l-n">
          <tl-select
          name="month"
          id="month"
          label="Month *"
          labelText="name"
          :options="monthsData"
          v-model="lopMonth"
          v-validate="'required'"
          :classname="errors.has('month')"
          :errormsg="errors.first('month')"
          @change="
            (val) => {
              lopMonth = val; typeOfLoss= ''
            }
          "
          ></tl-select>
        </div>
        <div class="col-3 padding-l-n" :key="componentKey">
          <search-dropdown
            class="custom-width-search margin-t-15px"
            :placeholder="'Search Employee Name/Code'"
            :clearRequired="true"
            :employeeData="employeeData"
            @clear="(val) =>{empId=null; lopData=[]; rlopData=[];selectDaysDates = '';isSelectDaysDatesDisabled=false;}"
            @getList="searchEmployeesByName($event)"
            @empselected="(emp)=>selectedEmp(emp)"
          />
        </div>
        <div class="col-3 ml-10">
          <tl-select
            label="Select Type"
            name="type"
            :value="typeOfLoss"
            :options="typeOfLossOptions"
            @change="(val)=>{typeOfLoss = val; fetchAll(); selectDaysDates = ''; showSelectedEmployeeCard=false; selectedEmployeeList=[]; }"
          />
        </div>
      </div>
      <div class="row margin-t-l" :disabled="!ifTeamleaderAnchorPermission">
        <!-- <div class="col-3 padding-l-n">
          <tl-select
            label="Select Days/Dates"
            v-model="selectDaysDates"
            name="days_dates"
            :disabled="isSelectDaysDatesDisabled"
            :options="selectDaysDatesOptions"
            @change="(val)=>{selectDaysDates = val; resetLopAndRlops()}"
          />
        </div> -->
        <div class="col-3 padding-l-n" v-if="showDatePicker" @click="fullday()">
          <!-- <div v-if="showDatePicker" class="label">Date/s</div> -->
          <date-picker
            ref="datepicker"
            :dates-disabled="{from: new Date(new Date().getFullYear(), (new Date().getMonth())+1, )}"
            @datevalue="(val)=>lopDate=val"
            label="Date/s"
            :inline="true"
            :value="lopDate"
            @click.native="onSelected(lopDate)"
          >
          </date-picker>
              <!-- <div class="action-section" v-show="showDropDown">

            <ul class="action-menu" >
              <li>
                <span class  @click="halfday()">Half Day</span>
              </li>
              <li>
                <span class @click="fullday()">Full Day</span>
              </li>
            </ul>
          </div> -->
        </div>
        <!-- <div
          class="selectedDates"
          v-if="showDatePicker && lopDate"
        >Selected Dates: {{lopDate}} DayType: {{dateDayCount==0.5 ?"HalfDay":"FullDay" }}</div> -->
      </div>

      <br />
    </div>
    <div class="row" v-else>
      <div class="col-12">
        <!-- <download-button
        @click="downloadUrl"
        ></download-button> -->
        <div class="download-btn">
        <div class="download-btn-container">
            <img src="@/assets/download.svg"  class="img" />
            <span class="text" @click="downloadUrl">Download Template</span>
            <loading-animation v-show="showLoader"></loading-animation>
         </div>
      </div>
      </div>
      <!-- <upload-file class="margintop-16" @uploadTemplate="onUploadTemplate($event)"></upload-file> -->
      <upload class="margintop-16" :tobucket="false"  ref="bulkFile" @change="onUploadTemplate($event)"></upload>
    </div>
    <div v-if="uploadMethod == 'manualUpload'">
      <data-table
        class="margintop-20"
        v-if="!showDatePicker && typeOfLoss == 'LOP'"
        :columns="columnNames"
        :tableData="lopData"
        :checkbox="false"
        :search="search"
        :showinrow="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="slotprops.value.column.key=='month_name'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='no_of_lop'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <div class="inc-dec-bar" v-if="slotprops.value.column.key=='noofdays'">
            <img
              class="inc"
              src="@/assets/stroke-1-copy.svg"
              @click="increase('LOP', slotprops.value.index)"
            />
            <p>{{slotprops.value.record['noofdays']}}</p>
            <img
              class="dec"
              src="@/assets/stroke-1-copy.svg"
              @click="decrease('LOP',slotprops.value.index)"
            />
          </div>
        </template>
      </data-table>
      <data-table
        class="margintop-20"
        v-if="!showDatePicker && typeOfLoss == 'RLOP'"
        :columns="rlopColumnNames"
        :tableData="rlopData"
        :checkbox="false"
        :search="search"
        :showinrow="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="slotprops.value.column.key=='month_name'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='no_of_rlop'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <div class="inc-dec-bar" v-if="slotprops.value.column.key=='noofdays'">
            <img
              class="inc"
              :class="{'pointerEvents-none': slotprops.value.record['no_of_lop'] <= slotprops.value.record['no_of_rlop']}"
              src="@/assets/stroke-1-copy.svg"
              @click="increase('RLOP', slotprops.value.index)"
            />
            <p>{{slotprops.value.record['noofdays']}}</p>
            <img
              class="dec"
              :class="{'pointerEvents-none': !slotprops.value.record['no_of_rlop']}"
              src="@/assets/stroke-1-copy.svg"
              @click="decrease('RLOP',slotprops.value.index)"
            />
          </div>
        </template>
      </data-table>
      <button
        class="addMonth"
        @click="add"
        :disabled="(!typeOfLoss || !empId)"
      >
        <b>Add</b>
      </button>

      <div v-if="showSelectedEmployeeCard" class="selected-employees-list">
        <div class="row">
          <div class="col-4" v-for="(item, index) in selectedEmployeeList" :key="index">
            <div class="employee-card">
              <div>
                <img src="@/assets/user.svg" alt="actionIcon" />
              </div>
              <div class="cross" @click="deleteEmployee(index)">x</div>
              <div class="card-details">
                <div class="row">
                  <div class="col-8">
                    <h4>{{item.name}}</h4>
                    <p class="code"><b>{{item.code}}</b></p>
                    <p></p>
                  </div>
                  <div class="col-4">
                    <p class="lop-rlop-count">{{totalCount[index]}}</p>
                    <p>{{item.typeOfLoss}}</p>
                  </div>
                </div>
                <div v-if="item.type == 'days' && item.months.length">
                  <div v-if="item.typeOfLoss == 'LOP'">
                    <b>Month:</b>
                    <span
                      v-for="(dates, idx) in item.months"
                      :key="idx"
                    >&nbsp;{{dates.month_name}}: &nbsp;{{(item.months.length-1 > idx) ? dates.no_of_lop +',': dates.no_of_lop}}</span>
                  </div>
                  <div v-if="item.typeOfLoss == 'RLOP'">
                    <b>Month:</b>
                    <span
                      v-for="(dates, idx) in item.months"
                      :key="idx"
                    >&nbsp;{{dates.month_name}}: &nbsp;{{(item.months.length-1 > idx) ? dates.no_of_rlop +',': dates.no_of_rlop}}</span>
                  </div>
                </div>
                <div v-else>
                  <div v-if="item.typeOfLoss == 'LOP'">
                    <b>Dates:</b>
                    <span v-for="(item, idx) in item.lop_dates" :key="idx">{{item}}</span>
                  </div>
                  <div v-if="item.typeOfLoss == 'RLOP'">
                    <b>Dates:</b>
                    <span v-for="(item, idx) in item.rlop_dates" :key="idx">{{item}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Lop and RLOP has been successfully added.`"
      btnText="Back To Upload LOP & RLOP"
      @back="backToUploadPage"
    ></pop-up-message>
    <pop-up-message
      v-if="showSuccessBulkUploadMsg"
      :message="responseMsg"
      btnText="Back To Upload LOP & RLOP"
      @back="backToUploadPage()"
    ></pop-up-message>
    <bottom-action-container v-if="uploadMethod == 'manualUpload'">
      <btn-grp slot="end">
        <btn text="Reset" type="secondary" class @click="resetForm()"></btn>
        <btn
          text="Submit"
          type="primary"
          :disabled="!selectedEmployeeList.length"
          class
          @click="performAction()"
        ></btn>
      </btn-grp>
    </bottom-action-container>
  </div>
</template>


<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { createDecipheriv } from 'crypto';
import { mapActions, mapGetters, mapState } from "vuex";
import {S3} from "aws-sdk";
import axios from "axios";
import { monthOptionsObj } from "../../../../../../../apis/constants.js";
export default {
  components: {
    SearchDropdown
  },
  data() {
    return {
      componentKey: 0,
      responseMsg: "",
      datevalue:"",
      showSuccessBulkUploadMsg: false,
      showDropDown:false,
      dateDayCount:0,
      toast: false,
      errmsg: "",
      temparray: [],
      recentsearch: "All",
      bulkUploadTemplateUrl:'https://paylief.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Template_LOP_R_LOP.xlsx',
      showLoader: false,
      recents: "",
      sendData: [],
      sort: "Recently Joined",
      lopDates: [],
      monthsData: [],
      lopMonth: "",
      yearEnd:"",
      year:"",
      showDatePicker: false,
      lopRlopType: "",
      search: "",
      lopDate: "",
      uploadMethod: "manualUpload",
      lopMethod: "dates",
      showSuccessMsg: false,
      showSelectedEmployeeCard: false,
      selectDaysDates: "",
      selectDaysDatesOptions: ["No. of Days", "Date/s"],
      noofdays: 0,
      totalCount: [],
      empCode: "",
      typeOfLoss: "",
      selectDate: "",
      empName: "",
      empId: "",
      empMail: "",
      selectedDates: "12/12/1200",
      selectMonth: "Select",
      monthSelected: "",
      yearSelected: "",
      employeeData: [],
      typeOfLossOptions: ["LOP", "RLOP"],
      financialMonthOptions: monthOptionsObj.monthListForFinancialYear,
      monthOptions: monthOptionsObj.onlyMonths,
      columnNames: [
        {
          label: "Month",
          key: "month_name"
        },
        {
          label: "LOPs",
          key: "no_of_lop"
        },
        {
          label: "No. of Days",
          key: "noofdays"
        }
      ],
      lopData: [],
      rlopColumnNames: [
        {
          label: "Month",
          key: "month_name"
        },
        {
          label: "RLOPs",
          key: "no_of_rlop"
        },
        {
          label: "No. of Days",
          key: "noofdays"
        }
      ],
      rlopData: [],
      dataTableData: [],
      selectedEmployeeList: [],
      isSelectDaysDatesDisabled: false,
      monthDetails: [{ selectMonth: "", noofdays: 0 }],
      lopRlopValue: false,
      role: ""
    };
  },
  mounted() {
    this.getFinancialYear();
    this.fetchLopSetting();
  },
  activated() {
    this.toast = false;
    this.getOrgLeIdList();
    this.getFinancialYear();
    this.fetchLopSetting();
    this.resetForm();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      lopRlopData: state => state.dashboard.payroll.utilities.lopsandrlop,
      viewLopRlopData: state => state.dashboard.payroll.utilities.viewreport,
      globalEmployeeList: state =>
        state.globalapi.globalemployees.entityWiseData, //fetch employees data
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    leId() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.lopRlopValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    ...mapActions({
      act_create: "dashboard/payroll/utilities/uploadloprlop/create",
      act_fetchlop: "dashboard/payroll/utilities/uploadloprlop/fetchLOPsByEmp",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      act_upload_template:
        "dashboard/payroll/utilities/uploadloprlop/uploadTemplate",
      act_fetch_lop_setting: "onboard/settings/payroll_computation/fetchAll",
      act_get_lop_rlop_data: "payroll/lopsandrlops/getLopData",
      getPreSignedUrl: "payroll/lopsandrlops/createPreSigned",

    }),
    async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},

    async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "LOP_R_LOP.xls"); //or any other extension
          document.body.appendChild(link);
          link.click();
    } else {
      console.log('Failed to retrieve the download link.');
    }
  } catch (e) {
    console.error('Error during download:', e);
  }
},
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},
   
    /* server call to upload LOP excel */
    // async onUploadTemplate(event) {
    //   let currentMonthEnum = this.financialMonthOptions.find(
    //     item => item.name == this.monthOptions[new Date().getMonth()]
    //   ).value;
    //   let formData = new FormData();
    //   formData.append("files", event);
    //   formData.append("le_id", this.leId);
    //   formData.append(
    //     "financial_year",
    //     new Date().getMonth() > 2
    //       ? new Date().getFullYear()
    //       : new Date().getFullYear() - 1
    //   );
    //   formData.append("processing_month", currentMonthEnum);
    //   this.$root._data.isSaving = true;
    //   try {
    //     //console.log("formdata",formData);
    //     let res = await this.act_upload_template(formData);
    //     if (res.data.status) {
    //       this.responseMsg = res.data.message ? res.data.message : "";
    //       this.showSuccessBulkUploadMsg = true;
    //     }
    //     setTimeout(() => {
    //       this.$root._data.isSaving = false;
    //     }, 500);
    //   } catch (err) {
    //     //console.log("this is error msg",err);
    //     this.$root._data.isSaving = false;
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

    // Add here new code By Bhushan
    async onUploadTemplate(event) {
      //   let currentMonthEnum = this.financialMonthOptions.find(
      //   item => item.name == this.monthOptions[new Date().getMonth()]
      // ).value;
      let currentMonthEnum = this.payrollMonth.toLowerCase().substring(0,3);
      let year = this.payrollYear;
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.leId);
      formData.append(
        "financial_year",
        year
      );
      formData.append("processing_month", currentMonthEnum);

      this.$root._data.isSaving = true;
      try {
        let res = await this.act_upload_template(formData);
        if (res.data.status) {
          this.responseMsg = res.data.message ? res.data.message : "";
          this.$refs.bulkFile.uploaded = true;
          this.$refs.bulkFile.uploading = false;
          this.showSuccessBulkUploadMsg = true;
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    getFinancialYear(){
      let month = this.payrollMonth;
      if(month == "January" ||month == "February" || month=="March"){
          this.yearEnd = Number(this.payrollYear);
          this.year = Number(this.payrollYear)-1;
      }else {
          this.yearEnd = Number(this.payrollYear) + 1;
          this.year = Number(this.payrollYear);
      }
      this.monthsData =[
        {name:`April-${this.year}`, val:"apr"},
        {name:`May-${this.year}`, val:"may"},
        {name:`June-${this.year}`, val:"jun"},
        {name:`July-${this.year}`, val:"jul"},
        {name:`August-${this.year}`, val:"aug"},
        {name:`September-${this.year}`, val:"sep"},
        {name:`October-${this.year}`, val:"oct"},
        {name:`November-${this.year}`, val:"nov"},
        {name:`December-${this.year}`, val:"dec"},
        {name:`January-${this.yearEnd}`, val:"jan"},
        {name:`February-${this.yearEnd}`, val:"feb"},
        {name:`March-${this.yearEnd}`, val:"mar"},
      ]
    },

    // Add here new code By Bhushan
    /** Function to get the selected month enum by ID*/
    getCurrentMonthEnum(selectedMonth) {
      let selectedMonthEnum = "";
      switch (selectedMonth) {
        case "01":
          selectedMonthEnum = "jan";
          break;
        case "02":
          selectedMonthEnum = "feb";
          break;
        case "03":
          selectedMonthEnum = "mar";
          break;
        case "04":
          selectedMonthEnum = "apr";
          break;
        case "05":
          selectedMonthEnum = "may";
          break;
        case "06":
          selectedMonthEnum = "jun";
          break;
        case "07":
          selectedMonthEnum = "jul";
          break;
        case "08":
          selectedMonthEnum = "aug";
          break;
        case "09":
          selectedMonthEnum = "sep";
          break;
        case "10":
          selectedMonthEnum = "oct";
          break;
        case "11":
          selectedMonthEnum = "nov";
          break;
        case "12":
          selectedMonthEnum = "dec";
          break;

        default:
          break;
      }
      return selectedMonthEnum;
    },

    /* function to close the popup */
    backToUploadPage() {
      this.showSuccessMsg = false;
      this.showSuccessBulkUploadMsg = false;
    },
    halfday(){
      this.dateDayCount=0.5;
      this.showDropDown = false;
    },
    fullday(){
      this.dateDayCount=1;
      this.showDropDown = false;
    },
      onSelected(lopDate) {
        if(lopDate)
        {this.showDropDown =true;
            //this.dropdown();
        }
      //console.log('selected',this.lopDate)

      //return value
    },

    /* function to increase lop and rlop count */
    increase(val, index) {
      try {
        if (val == "LOP") {
          this.lopData[index].no_of_lop += 0.5;
          this.lopData[index].noofdays += 0.5;
        } else {
          this.rlopData[index].no_of_rlop += 0.5;
          this.rlopData[index].noofdays += 0.5;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async fetchLopSetting(){
       try {
        let res = await this.act_fetch_lop_setting(this.leId);
        this.lopRlopType = res.data.payload.data.lop_rlop_type;
        if(this.lopRlopType == "Day"){
          this.showDatePicker = false;
        } else{
          this.showDatePicker = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },


    /* function to decrease the lop and rlop count */
    decrease(val, index) {
      try {
        if (val == "LOP") {
          if (this.lopData[index].no_of_lop) {
            this.lopData[index].no_of_lop -= 0.5;
            this.lopData[index].noofdays -= 0.5;
          }
        } else {
          if (this.rlopData[index].no_of_rlop) {
            this.rlopData[index].no_of_rlop -= 0.5;
            this.rlopData[index].noofdays -= 0.5;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get employee searching by name */
    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.leId,
          key: val
        });
        this.employeeData = res.data.payload;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get employee's lop and rlop data */
    async fetchAll() {
      try {
        this.lopData = [];
        this.rlopData = [];
        let obj ={
              month: this.lopMonth.val,
              financial_year: this.lopMonth.name.split("-")[1],
              id: this.empId
            }
        if(this.typeOfLoss == "LOP"){
          obj.LOP = this.typeOfLoss
          let res = await this.act_get_lop_rlop_data(obj);
          this.lopData.push({
              month_name: this.lopMonth.name.split("-")[0],
              no_of_lop: res.data.payload.length > 0 ? res.data.payload[0].deduction_ratio_lop : 0,
              noofdays: 0
            })
        }else{
          obj.RLOP = this.typeOfLoss
          let res = await this.act_get_lop_rlop_data(obj);
          this.rlopData.push({
              month_name: this.lopMonth.name.split("-")[0],
              no_of_rlop: res.data.payload.length > 0 ? res.data.payload[0].reimbursement_ratio_rlop : 0,
              noofdays: 0
            })
        }
        // let res = await this.act_fetchlop(this.empId);
        // let d = new Date();
        // let currentMonth = d.getMonth();
        // this.lopData = [];
        // this.rlopData = [];
        // let index = this.financialMonthOptions.findIndex(
        //   item => item.name == this.monthOptions[currentMonth]
        // );
        // let monthList = this.financialMonthOptions.slice(0, index + 1);

        // if (
        //   res.data.payload.length &&
        //   res.data.payload[0].no_of_lop_days &&
        //   Object.keys(res.data.payload[0].no_of_lop_days).length
        // ) {
        //   this.selectDaysDates = "No. of Days";
        //   this.isSelectDaysDatesDisabled = true;
        // } else {
        //   if (
        //     res.data.payload.length &&
        //     res.data.payload[0].lop_days &&
        //     res.data.payload[0].lop_days.length
        //   ) {
        //     this.selectDaysDates = "Date/s";
        //     this.isSelectDaysDatesDisabled = true;
        //   } else {
        //     this.isSelectDaysDatesDisabled = false;
        //   }
        // }
        // if (this.typeOfLoss == "LOP") {
        //   monthList.forEach(element => {
        //     let obj =
        //       res.data.payload.length && res.data.payload[0].no_of_lop_days
        //         ? res.data.payload[0].no_of_lop_days[element.value]
        //         : 0;
        //     this.lopData.push({
        //       no_of_lop: obj ? obj : 0,
        //       lop_days: res.data.payload.length
        //         ? res.data.payload[0].lop_days
        //         : [],
        //       month_name: element.name,
        //       month: element.value,
        //       monthIndex: element.index,
        //       financial_year:
        //         new Date().getMonth() > 2
        //           ? new Date().getFullYear()
        //           : new Date().getFullYear() - 1,
        //       noofdays: 0
        //     });
        //   });
        // } else {
        //   monthList.forEach(element => {
        //     let obj1 =
        //       res.data.payload.length && res.data.payload[0].no_of_rlop_days
        //         ? res.data.payload[0].no_of_rlop_days[element.value]
        //         : 0;
        //     let obj2 =
        //       res.data.payload.length && res.data.payload[0].no_of_lop_days
        //         ? res.data.payload[0].no_of_lop_days[element.value]
        //         : 0;
        //     this.rlopData.push({
        //       no_of_rlop: obj1 ? obj1 : 0,
        //       no_of_lop: obj2 ? obj2 : 0,
        //       rlop_days: res.data.payload.length
        //         ? res.data.payload[0].rlop_days
        //         : [],
        //       month_name: element.name,
        //       month: element.value,
        //       monthIndex: element.index,
        //       financial_year:
        //         new Date().getMonth() > 2
        //           ? new Date().getFullYear()
        //           : new Date().getFullYear() - 1,
        //       noofdays: 0
        //     });
        //   });
        //   let sumOfLops = 0;
        //   this.rlopData.forEach(element => {
        //     sumOfLops += element.no_of_lop;
        //     if (!sumOfLops) {
        //       this.toast = true;
        //       this.errmsg = "No Lops added for this employee!";
        //       this.isSelectDaysDatesDisabled = true;
        //     } else {
        //       this.toast = false;
        //     }
        //   });
        // }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to get employee's lop and rlop data after changing loss type */

    // To reset lops and rlops on changing days/dates (PL-1859) - 26/11/2019
    resetLopAndRlops() {
      try {
        if (this.typeOfLoss == "LOP") {
          this.lopData.forEach(item => {
            item.no_of_lop = 0;
          });
          this.lopDate = "";
        } else {
          this.rlopData.forEach(item => {
            item.no_of_rlop = 0;
          });
          this.lopDate = "";
        }
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    },

    /* function to delete already selected employees */
    deleteEmployee(index) {
      try {
        this.totalCount.splice(index, 1);
        this.selectedEmployeeList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to submit lop and rlop data */
    async performAction() {
      try {
        let reqObjList = [];
        let d = new Date();
        this.selectedEmployeeList.forEach(element => {
          let tempArray = [];
          let empID = "";
          //console.log(this.selectedEmployeeList, "[[[]]]");
          // if (element.months.length > 8) {
          //   element.months.forEach(element1 => {
          //     let indexArray = [0, 1, 2];
          //     // if (indexArray.some(item => item === element1.monthIndex)) {
          //     //   element1.month = element1.month + "/" + d.getFullYear();
          //     // } else {
          //     //   element1.month = element1.month + "/" + (d.getFullYear() - 1);
          //     // }
          //   });
          // } else {
          //   element.months.forEach(element2 => {
          //     element2.month = element2.month + "/" + d.getFullYear();
          //   });
          // }
          let lopObj = {};
          let lopDate = []
          let lopProcessingMonth = ""
          if (this.typeOfLoss == "LOP") {
            if(this.lopRlopType ==  "Day"){
              element.months.forEach(item => {
              lopProcessingMonth = item.month_name.substring(0,3).toLowerCase();
              lopObj = {
                month: item.month_name.substring(0,3),
                no_of_lop: item.no_of_lop
              };
            });
            reqObjList.push({
              lop: lopObj,
              processing_month_lop: lopProcessingMonth,
              employee_id:element.empID,
              financial_year: element.financial_year,
              empName: element.name
            });
            }else{
              lopDate.push(element.lop_dates)
              reqObjList.push({
                lop_days: lopDate,
                processing_month_lop: element.months.val,
                employee_id:element.empID,
                financial_year: element.financial_year,
                empName: element.name
              });
            }
              // lop: tempArray,
              // lop_days: element.lop_dates,
              // financial_year: element.financial_year,
              // processing_month_lop: this.financialMonthOptions.find(
              //   item => item.name == this.monthOptions[new Date().getMonth()]
              // ).value,
              // employee_id: element.empID
          } else {
            if(this.lopRlopType == "Day"){
              element.months.forEach(item => {
              lopProcessingMonth = item.month_name.substring(0,3).toLowerCase();
              lopObj = {
                month: item.month_name.substring(0,3),
                no_of_rlop: item.no_of_rlop
              };
              });
            reqObjList.push({
              rlop: lopObj,
              processing_month_rlop: lopProcessingMonth,
              employee_id:element.empID,
              financial_year: element.financial_year,
              empName: element.name
            });
            }else{
              lopDate.push(element.rlop_dates)
              reqObjList.push({
                rlop_days: lopDate,
                processing_month_rlop: element.months.val,
                employee_id:element.empID,
                financial_year: element.financial_year,
                empName: element.name
              });
            }
          }
        });
        this.$root._data.isSaving = true;
        let res = await this.act_create(reqObjList);
        setTimeout(() => {
          if (res.data.status) {
            this.showSuccessMsg = true;
            this.resetForm();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to reset form */
    resetForm() {
      try {
        this.selectDaysDates = "";
        this.typeOfLoss = "";
        this.lopDate = "";
        this.lopData = [];
        this.rlopData = [];
        this.lopMonth = null;
        this.empID = null;
        this.empName = null;
        this.empCode = null;
        this.componentKey += 1;
        this.toast = false;
        // this.empId = "";
        // this.empCode = "";
        // this.empName = "";
        // this.empMail = "";
        this.isSelectDaysDatesDisabled = false;
        this.selectedEmployeeList = [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to select employee */
    selectedEmp(emp) {
      try {
        this.empId = emp.id;
        this.empCode = emp.code;
        this.empName = emp.first_name + ' ' + (emp.last_name ? emp.last_name : "");   // PL_3009
        this.empMail = emp.email_id;
        if (this.typeOfLoss) {
          this.fetchAll();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to add employee in the list after adding lop and rlop data */
    add() {
      try {
        this.showSelectedEmployeeCard = true;
        if (!this.showDatePicker) {
          if (this.typeOfLoss == "LOP") {
            if (
              this.selectedEmployeeList.some(item => item.empID == this.empId)
            ) {
              let index = this.selectedEmployeeList.findIndex(
                item => item.empID == this.empId
              );
              if (index > -1) {
                this.selectedEmployeeList[index] = {
                  months: this.lopData,
                  name: this.empName,
                  code: this.empCode,
                  email: this.empMail,
                  type: "days",
                  typeOfLoss: "LOP",
                  financial_year:this.lopMonth.name.split("-")[1],
                  empID: this.empId
                };
                //console.log("employee data",this.selectedEmployeeList);
              }
            } else {
              this.selectedEmployeeList.push({
                months: this.lopData,
                name: this.empName,
                code: this.empCode,
                email: this.empMail,
                type: "days",
                typeOfLoss: "LOP",
                financial_year:this.lopMonth.name.split("-")[1],
                empID: this.empId
              });
                  //console.log("employee data2222",this.selectedEmployeeList);
            }
            this.selectedEmployeeList.forEach((item, index) => {
              this.totalCount[index] = 0;
              if (item.lop_dates) {
                this.totalCount[index] = item.lop_dates.length;
                  //console.log("employee total count data",this.totalCount[index]);
              } else {
                item.months.forEach(element => {
                  this.totalCount[index] += element.no_of_lop;
                });
              }
            })
                //console.log("employee data3333",this.selectedEmployeeList);
          } else {
            if (
              this.selectedEmployeeList.some(item => item.empID == this.empId)
            ) {
              let index = this.selectedEmployeeList.findIndex(
                item => item.empID == this.empId
              );
              if (index > -1) {
                this.selectedEmployeeList[index] = {
                  months: this.rlopData,
                  name: this.empName,
                  code: this.empCode,
                  type: "days",
                  typeOfLoss: "RLOP",
                  email: this.empMail,
                  financial_year:this.lopMonth.name.split("-")[1],
                  empID: this.empId
                };
              }
            } else {
              this.selectedEmployeeList.push({
                months: this.rlopData,
                name: this.empName,
                code: this.empCode,
                type: "days",
                typeOfLoss: "RLOP",
                email: this.empMail,
                financial_year:this.lopMonth.name.split("-")[1],
                empID: this.empId
              });
            }

            this.selectedEmployeeList.forEach((item, index) => {
              this.totalCount[index] = 0;
              if (item.rlop_dates) {
                this.totalCount[index] = item.rlop_dates.length;
              } else {
                item.months.forEach(element => {
                  this.totalCount[index] += element.no_of_rlop;
                });
              }
            });
          }
        } else {
          // let d = new Date(this.lopDate);
          // let dateObj = this.financialMonthOptions.find(
          //   item => item.name == this.monthOptions[d.getMonth()]
          // );
          // let value =
          //   ("0" + d.getDate()).slice(-2) +
          //   "/" +
          //   dateObj.value +
          //   "/" +
          //   d.getFullYear();
          //   //console.log("logging value",value,this.dateDayCount);
          if (this.typeOfLoss == "LOP") {
            if (
              this.selectedEmployeeList.some(item => item.empID == this.empId)
            ) {
              let index = this.selectedEmployeeList.findIndex(
                item => item.empID == this.empId
              );
              if (index > -1) {
                this.selectedEmployeeList[index] = {
                  months: this.lopMonth,
                  lop_dates: this.lopDate,
                  name: this.empName,
                  code: this.empCode,
                  type: "dates",
                  email: this.empMail,
                  financial_year:this.lopMonth.name.split("-")[1],
                  empID: this.empId
                };
              }
            } else {
              this.selectedEmployeeList.push({
                  months: this.lopMonth,
                  lop_dates: this.lopDate,
                  name: this.empName,
                  code: this.empCode,
                  type: "dates",
                  email: this.empMail,
                  financial_year:this.lopMonth.name.split("-")[1],
                  empID: this.empId
              });
            }
            this.selectedEmployeeList.forEach((item, index) => {
              this.totalCount[index] = 0;
              if (item.lop_dates) {
                //console.log("inside count.......",item.lop_dates.length);
                //item.lop_dates.length=this.dateDayCount;
                this.totalCount[index] = this.dateDayCount;//item.lop_dates.length;
                //console.log("total count....",this.totalCount[index]);
              } else {
                item.months.forEach(element => {
                  this.totalCount[index] += element.no_of_lop;
                });
              }
            });
          } else {
            if (
              this.selectedEmployeeList.some(item => item.empID == this.empId)
            ) {
              let index = this.selectedEmployeeList.findIndex(
                item => item.empID == this.empId
              );
              if (index > -1) {
                this.selectedEmployeeList[index] = {
                  months: this.lopMonth,
                  rlop_dates: this.lopDate,
                  name: this.empName,
                  code: this.empCode,
                  type: "dates",
                  email: this.empMail,
                  financial_year:this.lopMonth.name.split("-")[1],
                  empID: this.empId
                };
              }
            } else {
              this.selectedEmployeeList.push({
                  months: this.lopMonth,
                  rlop_dates: this.lopDate,
                  name: this.empName,
                  code: this.empCode,
                  type: "dates",
                  email: this.empMail,
                  financial_year:this.lopMonth.name.split("-")[1],
                  empID: this.empId
              });
            }

            this.selectedEmployeeList.forEach((item, index) => {
              this.totalCount[index] = 0;
              if (item.rlop_dates) {
                this.totalCount[index] = item.rlop_dates ? 1 : 0;
              } else {
                item.months.forEach(element => {
                  this.totalCount[index] += element.no_of_rlop;
                });
              }
            });
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

   ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.leId;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.lopRlopValue = data.data.user.permissions.lop_rlop ? true : false;
        //console.log("PL-3406",data);
    }

  }
};
</script>

<style lang="scss" scoped>
.content {
  margin-left: 20px;
  margin-top: 15px;
}
.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: 182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}

.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}

.addMonth {
  width: 95px;
  height: 35px;
  border-radius: 4px;
  border: solid 1px #34c0be;
  color: #34c0be;
  align-self: self-end;
  margin-bottom: 40px;
  margin-top: 20px;
  cursor: pointer;
}

.selected-employees-list {
  display: flex;
  margin-top: 8%;
  margin-bottom: 5%;
}

.inc-dec-bar {
  width: 110px;
  height: 35px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #dadada;
  background-color: #ffffff;
  justify-content: space-between;
  align-items: center;
  .inc {
    padding: 12px 10px 10px 10px;
    width: 32px;
    height: 35px;
    border-radius: 4px;
    transform: scaleY(-1);
    border: solid 1px #34c0be;
    cursor: pointer;
  }
  .dec {
    padding: 0px 10px;
    cursor: pointer;
    width: 32px;
    height: 35px;
    border-radius: 4px;
    border: solid 1px #34c0be;
  }
  // p {
  //   padding: 8px 0 0 10px;
  // }
}


.label {
  width: 40px;
  height: 20px;
  font-size: 12px;
  color: #646464;
}
.selectedDates {
  opacity: 0.5;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-top: 15px;
}
.pointerEvents-none {
  pointer-events: none;
}
.employee-card {
  display: grid;
  grid-template-columns: 50px auto;
  margin-bottom: 10px;
  grid-gap: 18px;
  max-width: 420px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  padding: 23px;
  position: relative;
  .cross {
    position: absolute;
    right: 18px;
    top: 0px;
    font-size: 25px;
    cursor: pointer;
  }
  .lop-rlop-count {
    font-size: 30px;
    font-weight: 500;
  }
  img {
    width: 55px;
    height: 55px;
    opacity: 0.8;
    border-radius: 41px;
  }
  .card-details {
    .code {
      margin-bottom: 2px;
      color: #979797;
      font-size: 12px;
    }
    p {
      margin-bottom: 5px;
    }
    .year-data {
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: normal;
      color: #535353;
    }
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
.ml-10{
  margin-left: 10%;
}
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: #34c0be;
    margin-left: 8px;
    cursor: pointer;
  }
}
</style>
